import styled from 'styled-components';
import solutionsBackground from '../../../assets/images/solutions-background.png';

export const SectionContainer = styled.section`
  height: 745px;
  width: 100%;
  background-color: #001233;
  background-image: linear-gradient(rgba(0, 18, 51, 0.46), rgba(0, 18, 51, 0.7)), url(${solutionsBackground});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: scroll;
  display: flex;
  position: relative;
  
  @media (max-width: 768px) {
    flex-direction: column;
    height: auto;
    min-height: 100vh;
    background-position: center center;
  }
  
  @media (max-width: 480px) {
    min-height: 90vh;
  }
`;

export const LeftContainer = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: 12rem;
  position: relative;
  
  @media (max-width: 1024px) {
    padding-left: 8rem;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    padding: 3rem 2rem;
    justify-content: flex-start;
    min-height: auto;
  }
  
  @media (max-width: 480px) {
    padding: 2rem 1.5rem;
    min-height: auto;
  }
`;

export const RightContainer = styled.div`
  width: 50%;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  position: relative;
  padding-top: 80px;
  
  @media (max-width: 768px) {
    padding-top: 70px;
    align-items: center;
    text-align: center;
  }
  
  @media (max-width: 480px) {
    padding-top: 60px;
  }
`;

export const LogoContainer = styled.div`
  position: absolute;
  top: 0;
  left: -15px;
  margin-bottom: 2rem;
  
  img {
    height: 50px;
    filter: brightness(0) invert(1);
  }
  
  @media (max-width: 768px) {
    position: relative;
    left: 0;
    margin-bottom: 1.5rem;
    align-self: center;
    
    img {
      height: 45px;
    }
  }
  
  @media (max-width: 480px) {
    margin-bottom: 1rem;
    
    img {
      height: 40px;
    }
  }
`;

export const Title = styled.h2`
  font-size: 1.8rem;
  font-weight: 400;
  line-height: 1.3;
  margin-bottom: 2rem;
  color: #fff;
  max-width: 560px;
  width: 100%;
  white-space: normal;
  word-break: keep-all;
  
  @media (max-width: 768px) {
    font-size: 1.6rem;
    margin-bottom: 1.5rem;
    max-width: 100%;
    text-align: center;
  }
  
  @media (max-width: 480px) {
    font-size: 1.4rem;
    margin-bottom: 1.2rem;
    line-height: 1.4;
  }
`;

export const Description = styled.p`
  font-size: 1rem;
  line-height: 1.5;
  color: #fff;
  opacity: 0.9;
  max-width: 520px;
  width: 100%;
  white-space: pre-line;
  
  @media (max-width: 768px) {
    font-size: 0.95rem;
    max-width: 100%;
    text-align: center;
    line-height: 1.6;
  }
  
  @media (max-width: 480px) {
    font-size: 0.9rem;
    line-height: 1.7;
  }
`;